import React from "react";
import { NavLink } from "react-router-dom";

import { concatImageS3 } from "../../shared/utils";
const myAvatar = concatImageS3("account/avatar.svg");
import { getUser } from "../../vanilla/userUtils";

import { Card } from "@maxmilhas/hangar-components-atomic/public";
import { css } from 'emotion';
import MenuNavLink from './MenuNavLinks';
import { myAccountMenu, menuList, pageTitle, helloUser, containerMyAccountMenu } from './styles/my-account-menu';

const addresses = [
	{
		icon: 'icon-user',
		address: '/cliente/editar/dados-cadastro',
		title: 'Meus Dados'
	}, 
	{
		icon: 'icon-plane',
		address: '/cliente/minhas-viagens-light',
		title: 'Minhas viagens'
	},
	{
		icon: 'icon-miles',
		address: '/cliente/minhas-ofertas',
		title: 'Minhas ofertas'
	}
]

function MyAccountMenu(props) {
	return (
		<Card className={css`${containerMyAccountMenu}`}>
			<div className={css`${myAccountMenu}`}>
				<div className={css`${menuList}`}>
					<h1 className={css`${pageTitle}`}>
						Minha Conta
					</h1>
					<p className={css`${helloUser}`}>Olá, {getUser() ? getUser().name.split(' ')[0] : ""}!</p>
				</div>
				<MenuNavLink 
					menuLinks={addresses} 
				/>
			</div>
		</Card>
	);
}

export default MyAccountMenu;
